import React from "react";
import "../../assets/css/seller-dashboard.css";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Seller_sidebar from "./Seller-sidebar/Seller_sidebar";
import Seller_tabs_list from "./Seller-sidebar/Seller_tabs_list";
import SellerHeader from "../../components/SellerHeader/SellerHeader";
import SellerFooter from "../../components/SellerFooter/SellerFooter";

const Seller_customer = () => {
	return (
		<>
			{/* Header starts here */}
			<SellerHeader />
			{/* Header ends here */}
			<section className="dashboard">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<Seller_sidebar />
						</div>
						<div className="col-lg-8 cus">
							<Seller_tabs_list />

							<div className="row">
								<div className="col-lg-12">
									<div className="recent-orders-wrapper">
										<div className="content-wrapper">
											<h5>Customer</h5>
										</div>
										<div className="table-responsive">
											<table className="table">
												<thead>
													<tr>
														<th scope="col">First Name</th>
														<th scope="col">Last Name</th>
														<th scope="col">Customer Email</th>
														<th scope="col">Phone Number</th>
														<th scope="col">Order Id</th>
													</tr>
												</thead>
												<tbody>
													<tr>
														<th className="num" scope="row">
															Lorem ipsum
														</th>
														<td className="name">Lorem ipsum</td>
														<td className="price">example.@gmail.com</td>
														<td className="item">+923456789</td>
														<td className="item">#12345</td>
													</tr>
													<tr>
														<th className="num" scope="row">
															Lorem ipsum
														</th>
														<td className="name">Lorem ipsum</td>
														<td className="price">example.@gmail.com</td>
														<td className="item">+923456789</td>
														<td className="item">#12345</td>
													</tr>
													<tr>
														<th className="num" scope="row">
															Lorem ipsum
														</th>
														<td className="name">Lorem ipsum</td>
														<td className="price">example.@gmail.com</td>
														<td className="item">+923456789</td>
														<td className="item">#12345</td>
													</tr>
													<tr>
														<th className="num" scope="row">
															Lorem ipsum
														</th>
														<td className="name">Lorem ipsum</td>
														<td className="price">example.@gmail.com</td>
														<td className="item">+923456789</td>
														<td className="item">#12345</td>
													</tr>
													<tr>
														<th className="num" scope="row">
															Lorem ipsum
														</th>
														<td className="name">Lorem ipsum</td>
														<td className="price">example.@gmail.com</td>
														<td className="item">+923456789</td>
														<td className="item">#12345</td>
													</tr>
												</tbody>
											</table>
										</div>
										<div className="paginations_results">
											<div className="showing_results">
												<p>
													Showing <b>7</b> of over 50 <b>results</b>
												</p>
											</div>
											<ul className="paginations">
												<li className="arrow prev-arrow">
													<i
														className="fa fa-angle-left"
														aria-hidden="true"
													></i>
												</li>
												<li className="pagi">1</li>
												<li className="pagi">2</li>
												<li className="pagi">3</li>
												<li className="pagi">..</li>
												<li className="pagi">90</li>
												<li className="arrow right-arrow">
													<i
														className="fa fa-angle-right"
														aria-hidden="true"
													></i>
												</li>
											</ul>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* Footer starts here */}
			<SellerFooter />
			{/* Footer ends here */}
		</>
	);
};

export default Seller_customer;
